import React, { Component } from "react";
import { setDynamicForm } from "../../../services/badge";

export class DetailsModal extends Component {
    state = {
        rowsNumbers: [1],
        rowsData: [{ id: 1, name: "", label: "", placeholder: "" }]
    };

    removeRow = num => {
        const newRowsNumbers = [...this.state.rowsNumbers].filter(rowNumber => {
            return rowNumber !== num;
        });
        const newData = [...this.state.rowsData].filter(rowData => {
            return rowData.id !== num;
        });
        this.setState({
            rowsNumbers: newRowsNumbers,
            rowsData: newData
        });
    };

    addRow = () => {
        const newData = [
            ...this.state.rowsData,
            {
                id:
                    this.state.rowsNumbers[this.state.rowsNumbers.length - 1] +
                    1,
                name: "",
                label: "",
                placeholder: ""
            }
        ];
        const newRowsNumbers = [
            ...this.state.rowsNumbers,
            this.state.rowsNumbers[this.state.rowsNumbers.length - 1] + 1
        ];
        this.setState({
            rowsNumbers: newRowsNumbers
        });
        this.setState({
            rowsData: newData
        });
    };

    handleChange = (number, e) => {
        const newData = [...this.state.rowsData].map(rowData => {
            if (rowData.id === number) {
                rowData[e.target.id] = e.target.value;
            }
            return rowData;
        });
        this.setState({
            rowsData: newData
        });
    };

    componentDidMount() {
        this.setState({
            rowsData: JSON.parse(this.props.item.dynamic_form),
            rowsNumbers: JSON.parse(this.props.item.dynamic_form).map(item => {
                return item.id;
            })
        });
    }

    SendData = () => {
        setDynamicForm({
            badge_id: this.props.item.id,
            badge_data: this.state.rowsData
        })
            .then(res => {
                this.props.hideDetails();
            })
            .catch(error => {
                this.context.state.handelError(error);
            });
    };

    render() {
        return (
            <div className="model-container model-center model-backdrop-show ">
                <div
                    aria-labelledby="model-title"
                    aria-describedby="model-content"
                    className="model-popup model-modal model-show details-modal"
                    role="dialog"
                    aria-live="assertive"
                    aria-modal="true"
                >
                    <table className="table table-bordered" id="dynamicTable">
                        <tbody>
                            <tr>
                                <th>Field Name</th>
                                <th>Field Label</th>
                                <th>Field Placeholder</th>
                                <th>Action</th>
                            </tr>
                            {this.state.rowsNumbers.map(rowNumber => {
                                return (
                                    <tr>
                                        <td>
                                            <input
                                                onChange={e =>
                                                    this.handleChange(
                                                        rowNumber,
                                                        e
                                                    )
                                                }
                                                value={
                                                    this.state.rowsData.find(
                                                        rowData =>
                                                            rowData.id ===
                                                            rowNumber
                                                    ).name
                                                }
                                                required
                                                type="text"
                                                id="name"
                                                placeholder="Enter field name"
                                                className="form-control form-control-sm"
                                            />
                                        </td>
                                        <td>
                                            <input
                                                onChange={e =>
                                                    this.handleChange(
                                                        rowNumber,
                                                        e
                                                    )
                                                }
                                                value={
                                                    this.state.rowsData.find(
                                                        rowData =>
                                                            rowData.id ===
                                                            rowNumber
                                                    ).label
                                                }
                                                required
                                                type="text"
                                                id="label"
                                                placeholder="Enter field label "
                                                className="form-control form-control-sm"
                                            />
                                        </td>
                                        <td>
                                            <input
                                                onChange={e =>
                                                    this.handleChange(
                                                        rowNumber,
                                                        e
                                                    )
                                                }
                                                value={
                                                    this.state.rowsData.find(
                                                        rowData =>
                                                            rowData.id ===
                                                            rowNumber
                                                    ).placeholder
                                                }
                                                type="text"
                                                id="placeholder"
                                                placeholder="Enter field placeholder"
                                                className="form-control form-control-sm"
                                            />
                                        </td>
                                        <td>
                                            {rowNumber !==
                                            this.state.rowsNumbers[0] ? (
                                                <button
                                                    type="button"
                                                    className="btn btn-danger remove-tr btn-sm"
                                                    onClick={() =>
                                                        this.removeRow(
                                                            rowNumber
                                                        )
                                                    }
                                                >
                                                    Remove
                                                </button>
                                            ) : (
                                                <button
                                                    type="button"
                                                    name="add"
                                                    id="add"
                                                    onClick={this.addRow}
                                                    className="btn btn-success btn-sm"
                                                >
                                                    Add More
                                                </button>
                                            )}
                                        </td>
                                    </tr>
                                );
                            })}
                        </tbody>
                    </table>
                    <div className="col-12">
                        <button
                            type="button"
                            onClick={this.SendData}
                            className="btn btn-primary mr-2"
                        >
                            Submit
                        </button>
                        <button
                            type="button"
                            onClick={this.props.hideDetails}
                            className="btn btn-default"
                        >
                            Cancel
                        </button>
                    </div>
                </div>
            </div>
        );
    }
}

export default DetailsModal;



// WEBPACK FOOTER //
// ./src/components/admin/badges/DetailsModal.js